import * as Yup from "yup";
import { Strings } from "@app/constants";

export const checkValutionSchema = Yup.object()
  .shape({
    carNumber: Yup.string().required(
      Strings.validation.fieldRequired(Strings.validation.carNumber),
    ),
    phone: Yup.string().required(
      Strings.validation.fieldRequired(Strings.validation.phoneNumber),
    ),
  })
  .required();
